import * as React from 'react';

var _circle, _path, _path2, _path3, _path4;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgArb = function SvgArb(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#2D374B"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#2D374B",
        fillRule: "evenodd",
        d: "M76.963 47.521 70.629 58.27 87.11 84.925l5.96-3.453L61.9 99.535c-.6.217-1.302.205-1.898-.037l-1.407-.81-11.78-6.775 28.267-47.946-12.526.046-28.34 46.765-3.3-1.9 28.003-44.91-4.752-.126c-4.05-.057-8.412.995-10.414 4.264L27.85 72.754l-.047-28.617q.01-.158.038-.31a2.64 2.64 0 0 1 1.504-1.936l.115-.052 29.836-17.29.107-.067q.13-.086.275-.159a2.7 2.7 0 0 1 2.349-.011l30.738 17.68a2.65 2.65 0 0 1 1.223 2.108l.048 30.013zM61.148 74.403l11.897 18.673 10.99-6.37L68.411 62.08z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#28A0F0",
        d: "m61.148 74.403 11.898 18.673 10.99-6.37L68.41 62.08zM94.044 79.216l-.008-5.103L76.963 47.52l-6.334 10.748L87.11 84.924l5.96-3.453a2.64 2.64 0 0 0 .975-1.923z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m22.5 84.029 8.415 4.849 28.004-44.91-4.752-.126c-4.05-.057-8.412.995-10.414 4.264L27.85 72.754l-5.35 8.22zM75.082 43.967l-12.526.046-28.34 46.765 9.906 5.704 2.694-4.569z"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#96BEDC",
        d: "M99.323 43.903c-.105-2.62-1.523-5.018-3.745-6.414L64.437 19.58c-2.198-1.107-4.943-1.108-7.145-.001-.26.131-30.283 17.543-30.283 17.543q-.626.301-1.193.707a7.92 7.92 0 0 0-3.316 6.057v37.087l5.35-8.22-.047-28.617q.01-.156.038-.309a2.64 2.64 0 0 1 1.063-1.68c.141-.101 30.678-17.777 30.775-17.825a2.71 2.71 0 0 1 2.348-.011l30.738 17.68a2.65 2.65 0 0 1 1.224 2.107v35.45c-.038.75-.335 1.447-.92 1.922l-5.959 3.454-3.074 1.782-10.99 6.369L61.9 99.535c-.6.217-1.302.204-1.898-.038l-13.186-7.584-2.694 4.569 11.85 6.822c.392.223.741.421 1.028.582.444.248.746.415.853.467.842.409 2.054.647 3.146.647a7.9 7.9 0 0 0 2.901-.546l32.373-18.748c1.858-1.44 2.951-3.61 3.05-5.962z"
    })));
};

export { SvgArb as ReactComponent };
//# sourceMappingURL=ARB.svg.es.js.map
